// extracted by mini-css-extract-plugin
export default {"templatesButtons":"IncomingChat_templatesButtons_eTk9N"};